import gql from 'graphql-tag';

export const UPSERT_TERRITORY_RULE = gql`
  mutation UpsertTerritoryRule(
    $ruleId: Int
    $territoryId: String!
    $territoryName: String!
    $territoryGroupId: Int!
    $definition: NewRuleDefinitionResponse
    $effectiveDate: AWSDate
    $endDate: AWSDate
    $color: String
    $inheritsFrom: [InheritedRule]
  ) {
    upsertTerritoryRule(
      input: {
        ruleId: $ruleId
        territoryId: $territoryId
        territoryName: $territoryName
        territoryGroupId: $territoryGroupId
        definition: $definition
        effectiveDate: $effectiveDate
        endDate: $endDate
        color: $color
        inheritsFrom: $inheritsFrom
      }
    ) {
      __typename
    }
  }
`;
